export function formatPriceCalendar(value, locale = 'en-US', currencyCode = 'USD'): string {
	let currencySymbol = new Intl.NumberFormat(locale, {
		style: 'currency',
		currency: currencyCode
	}).formatToParts(0).find(part => part.type === 'currency')?.value.replace(/[A-Z]{2,}/g, '');

	if (!currencySymbol) {
		currencySymbol = '';
	}

	let formattedPrice: string;

	if (value >= 10000) {
		formattedPrice = `${Math.floor(value / 1000)}k`;
	} else {
		const hasDecimal = value % 1 !== 0;
		formattedPrice = new Intl.NumberFormat(locale, {
			style: 'currency',
			currencyDisplay: 'narrowSymbol',
			currency: currencyCode,
			minimumFractionDigits: hasDecimal ? 2 : 0,
			maximumFractionDigits: 2
		}).format(value);
	}

	if (currencyCode === 'USD') {
		formattedPrice = formattedPrice.replace('US$', '$')
	}

	if (value >= 10000) {
		return ['$', '£'].includes(currencySymbol)
			? `${currencySymbol}${formattedPrice}`
			: `${formattedPrice} ${currencySymbol}`;
	}

	return formattedPrice;
}
